<template>
  <div class="newPer" v-wechat-title="headtitle">
    <header>
      <h3>新人臻享&nbsp;专享礼遇</h3>
      <p>{{ giftNumChineseShow(list) }}重可选</p>
    </header>
    <div>
      <ul>
        <li
          :key="index"
          @click="newPerClick(item)"
          v-for="(item, index) of list"
        >
          <img :src="item.itemimg" />
        </li>
      </ul>
    </div>
    <div @click="homeClick" class="homeBtn">
      <img src="/static/images/homebtn.png" />
    </div>
  </div>
</template>

<script>
import {
  fenxiang,
  isApp,
  basepath,
  isWeixin,
  wxAjaxData,
  browHistory,
  exclusiveidFn,
  pointParams
} from '../../assets/common/js/config'
import wx from 'weixin-js-sdk'
export default {
  name: 'actintroduce',
  data() {
    return {
      list: [],
      headtitle: '',
      bannerImg: '',
      title: encodeURIComponent('五一大惠战，爆款买就送！'),
      desc: encodeURIComponent(
        '限时福利，爆款买就送，20元满减券叠加哦，赶紧抢购啦~'
      ),
      img: basepath + '/static/images/actruleshareimg.png',
      shareUrl: basepath + '/Wxmall/WeChat/share' + wxAjaxData
    }
  },
  mounted: function() {
    window.scrollTo(0, 0)
    this.getData()
  },
  destroyed: function() {
    this.$toast.clear()
    this.$dialog.close()
  },
  beforeRouteEnter(to, from, next) {
    next()
  },
  beforeRouteLeave(to, from, next) {
    // 记录离开时的位置
    next()
  },
  methods: {
    getData: function() {
      var url
      if (this.$route.query.path == 'Friends') {
        // 小程序朋友圈广告标识
        url = this.$ajax.getGroupItemList_URL + '?group_code=ADITEM'
        this.title = '补水神器，亮肤绝品，速来特惠尝鲜'
        this.desc = ''
        this.headtitle = this.$route.meta.title = '新人臻享，专享礼遇'
      }
      var that = this
      that.$customRequestAjax(url).then((res) => {
        if (res.data.code === 200) {
          if (isWeixin()) {
            var arg = isApp()
            if (arg == '') {
              if (this.$route.query.path == 'Friends') {
                fenxiang({ path: 'actintroduce' })
              }
            }
          }
          that.list = res.data.itemlist
          that.bannerImg = res.data.bannerimg
        }
      })
    },
    homeClick: function() {
      var arg = isApp()
      if (arg == '') {
        if (this.$route.query.type) {
          var that = this
          if (
            that.waptoken.waptoken &&
            that.waptoken.waptoken == that.waptoken.tourists
          ) {
            localStorage.setItem('htmlurl', window.location)
            window.location = '/login?routeval=html'
            return
          }
          browHistory(
            {
              type: that.$route.query.type,
              page: window.location.href
            },
            function() {
              that.$router.replace(
                '/?exclusiveid=' + exclusiveidFn() + pointParams('&')
              )
            }
          )
        } else {
          this.$router.replace(
            '/?exclusiveid=' + exclusiveidFn() + pointParams('&')
          )
        }
      } else if (arg.indexOf('xcx') < 0) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({
            type: 'goIndex'
          })
        )
      } else {
        wx.miniProgram.reLaunch({
          url:
            '/pages/index/main?exclusiveid=' +
            exclusiveidFn() +
            pointParams('&')
        })
      }
    },
    newPerClick: function(items) {
      var that = this
      var arg = isApp()
      if (arg == '') {
        if (this.$route.query.type) {
          if (
            that.waptoken.waptoken &&
            that.waptoken.waptoken == that.waptoken.tourists
          ) {
            localStorage.setItem('htmlurl', window.location)
            window.location = '/login?routeval=html'
            return
          }
          browHistory(
            {
              type: that.$route.query.type,
              page: window.location.href
            },
            function() {
              that.$router.push(
                '/productdetail' +
                  '?itemid=' +
                  items.itemid +
                  '&exclusiveid=' +
                  exclusiveidFn() +
                  pointParams('&')
              )
            }
          )
        } else {
          if (that.$route.query.path == 'Friends') {
            window.location.href =
              '/static/wx/html/38ylactpage/annProduct.html?path=Friends&itemid=' +
              items.itemid +
              '&exclusiveid=' +
              exclusiveidFn() +
              pointParams('&')
          } else {
            that.$router.push(
              '/productdetail' +
                '?itemid=' +
                items.itemid +
                '&exclusiveid=' +
                exclusiveidFn() +
                pointParams('&')
            )
          }
        }
      } else if (arg.indexOf('xcx') < 0) {
        if (that.$route.query.path == 'Friends') {
          window.location.href =
            '/static/wx/html/38ylactpage/annProduct.html?path=Friends&itemid=' +
            items.itemid +
            '&exclusiveid=' +
            exclusiveidFn() +
            pointParams('&') +
            arg
        } else {
          var obj = {
            type: 'goItemDetail',
            itembaseid: items.itemid
          }
          window.ReactNativeWebView.postMessage(JSON.stringify(obj))
        }
      } else {
        if (that.$route.query.path == 'Friends') {
          window.location.href =
            '/static/wx/html/38ylactpage/annProduct.html?path=Friends&itemid=' +
            items.itemid +
            '&exclusiveid=' +
            exclusiveidFn() +
            pointParams('&') +
            arg
        } else {
          wx.miniProgram.navigateTo({
            url:
              '/pages/product/main?itemid=' +
              items.itemid +
              '&exclusiveid=' +
              exclusiveidFn() +
              pointParams('&')
          })
        }
      }
    },
    giftNumChineseShow(list) {
      switch (list.length) {
        case 0:
          return '零'
          break
        case 1:
          return '一'
          break
        case 2:
          return '二'
          break
        case 3:
          return '三'
          break
        case 4:
          return '四'
          break
        case 5:
          return '五'
          break
        case 6:
          return '六'
          break
        case 7:
          return '七'
          break
        case 8:
          return '八'
          break
        case 9:
          return '九'
          break
        case 10:
          return '十'
          break
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.newPer {
  background: #fff;
  background: url(/static/images/38act/friendactintroduceback.png) repeat-y left
    top;
  background-size: 100%;
  /*min-height: 100%;*/
  header {
    padding-top: 0.28rem;
    h3 {
      text-align: center;
      color: #ffffff;
      font-size: 0.35rem;
      margin-top: 0.1rem;
    }
    p {
      text-align: center;
      font-size: 0.21rem;
      color: #ffffff;
    }
  }
  ul {
    /*margin: 0.2rem 0.15rem;*/
    li {
      width: 100%;
      margin-bottom: 0.15rem;
      &:nth-of-type(n) {
        margin-top: 0.19rem;
      }
      &:first-of-type {
        margin-top: 0.17rem;
      }
      img {
        width: 92%;
        height: auto;
        margin: 0 auto;
      }
    }
  }
  .homeBtn {
    z-index: 10;
    position: fixed;
    right: 0.1rem;
    bottom: 0.6rem;
    width: 0.4rem;
    height: 0.4rem;
    border-radius: 50%;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    -webkit-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    -moz-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    -ms-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    -o-box-shadow: 0 0.01rem 0.05rem 0 rgba(159, 159, 159, 0.5);
    display: flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -webkit-flex;
    display: -o-flex;
    flex-direction: column;
    -moz-flex-direction: column;
    -ms-flex-direction: column;
    -webkit-flex-direction: column;
    -o-flex-direction: column;
    justify-content: center;
    -moz-justify-content: center;
    -ms-justify-content: center;
    -webkit-justify-content: center;
    -o-justify-content: center;
    align-items: center;
    -moz-align-items: center;
    -ms-align-items: center;
    -webkit-align-items: center;
    -o-align-items: center;

    img {
      width: 0.4rem;
      height: 0.4rem;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/38actpage/friendactintroduce.vue